<template>
    <div>
        <v-row>
            <v-col cols="12" md="4">
                <select-primary v-model="query.searchKey" :items="searchKeys" class="v-input--density-default" />
            </v-col>
            <v-col cols="12" md="8" class="mt-n12px mt-md-0">
                <text-field-primary v-model="query.searchValue" placeholder="검색어를 입력하세요." class="v-input--density-default" @search="emit">
                    <template #append>
                        <v-btn icon large color="grey darken-4" class="v-btn--none-active-bg ma-n10px" @click="emit"><icon-search /></v-btn>
                    </template>
                </text-field-primary>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import TextFieldPrimary from "@/components/publish/parents/forms/text-field-primary.vue";
import SelectPrimary from "@/components/publish/parents/forms/select-primary.vue";
import IconSearch from "@/components/publish/styles/icons/icon-search.vue";

let searchKeys = [
    // { text: "전체", value: null },
    { text: "제목", value: "subject" },
    { text: "제목 + 내용", value: "subjectcontent" },
];

let initQuery = (value = {}) => ({
    ...(value || {}),
    searchKey: value?.searchKey || "subject",
    searchValue: value?.searchValue || null,
});

export default {
    components: {
        TextFieldPrimary,
        SelectPrimary,
        IconSearch,
    },
    data: () => ({
        searchKeys,

        query: initQuery(),
    }),
    methods: {
        sync() {
            this.query = initQuery(this.$route.query);
        },
        emit() {
            let { ...query } = this.query;

            delete query["page"];

            if (query["searchKey"] == "subject") delete query["searchKey"];
            if (!query["searchKey"]) delete query["searchKey"];
            if (!query["searchValue"]) delete query["searchValue"];

            this.$router.push({ query });
        },
    },
    watch: {
        "$route.query"() {
            this.sync();
        },
    },
    mounted() {
        this.sync();
    },
};
</script>

<style></style>
